import cx from 'classnames';
import { debounce } from 'lodash';
import React from 'react';

import styles from './styles.less';

export type AdType = 'bnr' | 'rect';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    adClassName?: string;
    id: string;
    type: AdType;
}

class DFPAd extends React.Component<Props> {
    render() {
        const {
            adClassName,
            className,
            id,
            type,
            ...props // tslint:disable-line:trailing-comma
        } = this.props;

        const cn = cx('ad', styles.ad, adClassName, {
            'ad--bnr': type === 'bnr',
            'ad--rect': type === 'rect',
        });

        return (
            <div { ...props } className={ cx(styles.dfp, styles[type], className) }>
                <div
                    className={ cn }
                    id={ id }
                />
            </div>
        );
    }

    public refresh = debounce(() => {
        if (window.AdFuel && typeof window.AdFuel.refresh === 'function') {
            window.AdFuel.refresh(this.props.id);
        }
    }, 300);
}

export default DFPAd;
